import React from 'react';
import ReportViewer from "./base/ReportViewer";

const AchalandagePeriode = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"AchalandagePériode"}/>
        </div>
    );
}
export default AchalandagePeriode;